"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationHistoryTranscriptCommonModelOutputSourceMedium = void 0;
exports.ConversationHistoryTranscriptCommonModelOutputSourceMedium = {
    Audio: "audio",
    Text: "text",
};
